import DialogPreview from 'components/DialogPreview/DialogPreview'
import { Checkbox, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { SelectItem } from 'components/Input/Select/SelectItem';
import { TextBoxItem } from 'components/Input/TextBox';
import { BtnSave } from 'components/Button/ButtonAll';
import CustomTablePagination from './CustomTablePagination';
import { FnAxios, FnDialog, I18n } from 'utilities/utilities';
import _ from "lodash";
import { ProviderSoldTicket } from '../TicketSold/TicketSoldForm';
import { I18NextNs } from 'enum/enum';

export const DialogTicketLose = ({
    isOpenRemark,
    setIsOpenRemark,
    row,
    controlledFields,
    indexClick,
    setValue,
}) => {

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();

    const {
        isView,
        objMuseum,
        setIsreRender,
        lstTotalTicketSell,
            form,
            nUserType

    } = useContext(ProviderSoldTicket);

    const [page, setPage] = useState(0);
    const [isOther, setIsOther] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [dataTable, setDataTable] = useState([]);
    const [selected, setSelected] = useState<readonly number[]>([]);
    const [optionDialog, setOptionDialog] = useState({
        lstBook: [],
        lstTicket: [],
        lstTicketAll: [],
        lstCause: [],
    });

    const formRemark = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
        defaultValues: {
            nBookId: null,
            nTicketId: null,
            nCauseId: null,
            sCause: null,
        },
    });

    const handleSubmit = () => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            DialogFn.CloseSubmit();
            let nCauseId = formRemark.getValues("nCauseId");
            let sRemark = formRemark.getValues("sCause");
            let nBookId = formRemark.getValues("nBookId");
            let nTicketId = formRemark.getValues("nTicketId");

            let isCheckDup = dataTable.findIndex(f => f.nTicketID === nTicketId && f.nBookID === nBookId);
            if (isCheckDup !== -1) {
                let sBook = "";
                let sTicket = "";
                let nIdxTicket = optionDialog.lstTicket.findIndex((f) => f.value === nTicketId);
                if (nIdxTicket > -1) {
                    sTicket = optionDialog.lstTicket[nIdxTicket].label;
                }

                let nIdxBook = optionDialog.lstBook.findIndex((f) => f.value === nBookId);
                if (nIdxBook > -1) {
                    sBook = optionDialog.lstBook[nIdxBook].label;
                }

                DialogFn.Warning("ตั๋วเล่มที่ " + sBook + " เลขที่ " + sTicket + " ได้มีการบันทึกไปแล้ว");
                return;
            }

            let isNew = nCauseId === "All";
            if (!isNew) {
                let nIdxOption = optionDialog.lstCause.findIndex((f) => f.value === nCauseId);
                if (nIdxOption > -1) {
                    sRemark = optionDialog.lstCause[nIdxOption].label;
                }
            }
            let sBook = "";
            let nIdxOptionBook = optionDialog.lstBook.findIndex(
                (f) => f.value === nBookId);
            if (nIdxOptionBook > -1) {
                sBook = optionDialog.lstBook[nIdxOptionBook].label;
            }

            let sTicket = "";
            let nIdxOptionTicket = optionDialog.lstTicket.findIndex(
                (f) => f.value === nTicketId
            );
            if (nIdxOptionTicket > -1) {
                sTicket = optionDialog.lstTicket[nIdxOptionTicket].label;
            }

            let lstDataClone = _.cloneDeep(dataTable);
            let nIDMax = dataTable.length > 0 ? Math.max(...dataTable.map(itm => { return itm.nID })) + 1 : 1;
            let objNew = {
                nID: nIDMax,
                nBookID: nBookId,
                sBook: sBook,
                nTicketID: nTicketId,
                sTicket: sTicket,
                nCauseID: isNew ? 0 : nCauseId,
                sRemark: sRemark,
                isNewRemark: isNew,
                isDelete: false,
            };
            let lstDataRemark = [...lstDataClone, ...[objNew]];

            setDataTable(lstDataRemark);

            // lstTotalTicketSell
            //set status ticket FE
            var indexTypeTicket = lstTotalTicketSell.findIndex(f => f.nTicketTypeID === row.nTicketTypeID)
            if (indexTypeTicket > -1) {
                let indexTicket = lstTotalTicketSell[indexTypeTicket].lstOptionTicketCheck.findIndex(f => f.nBookId === nBookId && f.nTicketId === nTicketId)
                if (indexTicket > -1) {
                    lstTotalTicketSell[indexTypeTicket].lstOptionTicketCheck[indexTicket].nStatusTicketId = 3;
                }
            }

            formRemark.reset({
                nBookId: null,
                nTicketId: null,
                nCauseId: null,
                sCause: null,
            });
            setIsOther(false);
            setValue(`lstSoldTicket.${indexClick}.lstRemark`, lstDataRemark);
            controlledFields[indexClick].nCountRemark = lstDataRemark.length;
            setIsreRender(value => !value)
        });
    };

    const handleClose = () => {
        let lstDataClone = _.cloneDeep(dataTable);
        setValue(`lstSoldTicket.${indexClick}.lstRemark`, lstDataClone);
        controlledFields[indexClick].nCountRemark = lstDataClone.length;

        
        setIsOpenRemark(false);
        if(setIsreRender)
        {
            setIsreRender(value => !value)
        }
    };

    const getOptionRemark = () => {
        let param = {
            nTicketTypeID: row.nTicketTypeID,
            // nMuseumId: objMuseum.nMuseumID,
            nMuseumId: (nUserType === 1 ? objMuseum.nMuseumID : form.getValues("nMuseumID")) + "",
            nStartBookID: row.nStartBook,
            nEndBookID: row.nEndBook,
            nStartTicketID: row.nStartTicketID,
            nEndTicketID: row.nEndTicketID,
        };
        DialogFn.BlockUI();

        AxiosFn.Get(`SoldTicket/GetOptionRemark`, param, (result) => {
            let objResult = result.objResult;
            //set value in list
            setOptionDialog({
                lstBook: objResult.lstOptionBook,
                lstTicketAll: objResult.lstOptionTicket,
                lstTicket: objResult.lstOptionTicket,
                lstCause: [
                    ...objResult.lstOptionCause,
                    {
                        label: "อื่นๆ",
                        value: "All",
                        sValue: null,
                        nParentID: null,
                        nOrder: null,
                        sOrder: null,
                    },
                ],
            });

            DialogFn.UnBlockUI();
        });
    };

    const isSelected = (id: number) => selected.indexOf(id) !== -1;

    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const newSelected = dataTable.map((n) => n.nID);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (id: number) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected: readonly number[] = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const handleDelete = () => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), () => {
            DialogFn.CloseSubmit();
            let newArrSelect = dataTable.filter(item => !selected.includes(item.nID));
            setDataTable(newArrSelect);
            setSelected([])
            
            let arrTicket = dataTable.filter(item => selected.includes(item.nID)).map(m => { return ({ nBookID: m.nBookID, nTicketID: m.nTicketID }) })
            var indexTypeTicket = lstTotalTicketSell.findIndex(f => f.nTicketTypeID === row.nTicketTypeID)
            if (indexTypeTicket > -1) {
                let arrBookId = arrTicket.map(m=>m.nBookID);
                let arrTicketId = arrTicket.map(m=>m.nTicketID);

                let lstSelect = lstTotalTicketSell[indexTypeTicket].lstOptionTicketCheck.filter(f => arrBookId.includes(f.nBookId) && arrTicketId.includes(f.nTicketId))
                if (lstSelect.length > 0) {
                    lstSelect.forEach(element => {
                        element.nStatusTicketId = 0;
                    });
                }
            }

        });
    }

    useEffect(() => {
        if (isOpenRemark && controlledFields.length > 0) {
            setDataTable(controlledFields[indexClick].lstRemark);
            setIsOther(false);
            getOptionRemark();
        }
    }, [isOpenRemark, controlledFields, indexClick]);

    return (
        <DialogPreview
            IsOpen={isOpenRemark}
            Title={"ข้อมูลบัตรเสียหาย"}
            required={false}
            sMaxWidth="md"
            onClose={handleClose}
            JsxDialogAction
            Close={false}
        >
            <Grid container spacing={2}>
                {isView ? null : <Grid item xs={12}>
                    <FormProvider {...formRemark}>
                        <Grid
                            container
                            spacing={2}
                            justifyContent={"flex-start"}
                            alignItems={"start"}
                        >
                            <Grid item xs={12} sm={8} md={4}>
                                <SelectItem
                                    id={`nBookId`}
                                    name={`nBookId`}
                                    label={"เล่มที่"}
                                    required={true}
                                    options={optionDialog.lstBook}
                                    disabled={false}
                                    onChange={(eValue) => {
                                        let arroption = optionDialog.lstTicketAll;
                                        if (eValue?.value) {
                                            arroption = arroption.filter(f => f.nParentID === eValue.value)
                                        }
                                        formRemark.setValue("nTicketId",null)
                                        setOptionDialog(value => {
                                            return ({
                                                ...value,
                                                lstTicket: arroption
                                            })
                                        })
                                    }
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sm={8} md={4}>
                                <SelectItem
                                    id={`nTicketId`}
                                    name={`nTicketId`}
                                    label={"เลขที่"}
                                    required={true}
                                    options={optionDialog.lstTicket}
                                    disabled={false}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <SelectItem
                                    id={`nCauseId`}
                                    name={`nCauseId`}
                                    label={"สาเหตุ"}
                                    required={true}
                                    options={optionDialog.lstCause}
                                    disabled={false}
                                    onChange={(objValue) => {

                                        setIsOther(objValue.value === "All");
                                    }}
                                />
                            </Grid>
                            {isOther ? (
                                <Grid item xs={12}>
                                    <TextBoxItem
                                        name={"sCause"}
                                        id={"sCause"}
                                        label={"อื่นๆ"}
                                        maxLength={250}
                                        type={"text"}
                                        required={isOther}
                                        disabled={false}
                                    />
                                </Grid>
                            ) : null}

                            <Grid item xs={12}>
                                <Grid container justifyContent={"center"} alignItems={"start"}>
                                    <Grid item>
                                        <BtnSave
                                            id="btn-save-remark"
                                            onClick={formRemark.handleSubmit(handleSubmit)}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                        </Grid>
                    </FormProvider>
                </Grid>}
                <Grid item xs={12}>
                    <TableContainer id="table-receive" component={Paper}>
                        <Table sx={{ minWidth: 500 }}>
                            <TableHead>
                                <TableRow >
                                    { !isView && <TableCell
                                        className="td-center"
                                        padding="checkbox"
                                        style={{ minWidth: "60px", width: '60px' }}
                                    >
                                        <Checkbox
                                            color="primary"
                                            indeterminate={selected.length > 0 && selected.length < dataTable.length}
                                            checked={dataTable.length > 0 && selected.length === dataTable.length}
                                            onChange={handleSelectAllClick}
                                            inputProps={{
                                                'aria-label': 'select all',
                                            }}
                                        />
                                    </TableCell>}
                                    <TableCell
                                        align="center"
                                        style={{ minWidth: "70px", width: "70px" }}
                                    >
                                        ที่
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ minWidth: "120px", width: "120px" }}
                                    >
                                        เล่มที่
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ minWidth: "120px", width: "120px" }}
                                    >
                                        เลขที่
                                    </TableCell>
                                    <TableCell align="center">หมายเหตุ</TableCell>
                                </TableRow>
                            </TableHead>
                            {dataTable.length > 0 ? (
                                <TableBody>
                                    {dataTable
                                        .slice(
                                            page * rowsPerPage,
                                            page * rowsPerPage + rowsPerPage
                                        )
                                        .map((row, index) => {
                                            let nNo = page * rowsPerPage + (index + 1);
                                            const isItemSelected = isSelected(row.nID);
                                            return (
                                                <TableRow key={nNo}>
                                                   { !isView && <TableCell padding="checkbox">
                                                        <Checkbox
                                                            color="primary"
                                                            checked={isItemSelected}
                                                            onClick={() => handleClick(row.nID)}
                                                            inputProps={{
                                                                'aria-labelledby': `aria-${nNo}`
                                                            }}
                                                        />
                                                    </TableCell>}
                                                    <TableCell align="center">{nNo}</TableCell>
                                                    <TableCell align="center">{row.sBook}</TableCell>
                                                    <TableCell align="center">{row.sTicket}</TableCell>
                                                    <TableCell align="left">{row.sRemark}</TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            ) : (
                                <TableRow key={"r-no-data"}>
                                    <TableCell align="center" colSpan={ isView ? 4 : 5}>
                                        ไม่พบข้อมูล
                                    </TableCell>
                                </TableRow>
                            )}
                        </Table>
                    </TableContainer>
                    <CustomTablePagination
                        dataTable={dataTable}
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                        page={page}
                        setPage={setPage}
                        colSpan={ isView ? 4 : 5}
                        onDelete={handleDelete}
                        isShowDelete={selected.length > 0}
                        OptionRowsPerPage={[5, 10, 25, 50, 100]}
                    />
                </Grid>
            </Grid>

        </DialogPreview>
    );
};

